var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"my-1 ml-1"},[_c('v-card-title',{staticStyle:{"font-family":"Raleway","color":"#888888"}},[_vm._v(" DRUG SCORES ")]),_c('v-card-text',[_c('div',{staticStyle:{"padding-left":"20px"},attrs:{"id":_vm.divId}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }